import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/AuthContext";
import axios from "axios";
import {
  formatAlertTagDisplayToSDK,
  formatAlertTagSDKToDisplay,
  formatAlertStatusSDKToDisplay,
} from "lib/utils";
import { AlertsControlBarContext } from "context/AlertsControlBarContext";
import {
  API_URL,
  ALERT_PROCESS_STATUS_SDK,
  INVESTIGATE_TAG_DISPLAY,
  INVESTIGATE_TAG_SDK,
} from "lib/constants";

import clsx from "clsx";
import { Input, Select } from "antd";
import { useSWRConfig } from "swr";
import "./alert-status-changer.scss";
import { showToast } from "ui/components/common";
import { changeAlertStatus } from "pages/dashboard/alerts/service";
interface AlertStatusChangerProps {
  alertId: string; // This prop must be passed to each AlertStatusChanger instance
}

const AlertStatusChanger: React.FC<AlertStatusChangerProps> = ({ alertId }) => {
  const { user } = useContext(AuthContext);
  const { mutate: globalMutate } = useSWRConfig();
  const { activeAlert, setActiveAlert } = useContext(AlertsControlBarContext);
  const [status, setStatus] = useState(activeAlert?.status);

  const [isOthersModalOpen, setIsOthersModalOpen] = useState(false);
  const [tag, setTag] = useState<INVESTIGATE_TAG_DISPLAY>();
  const [othersText, setOthersText] = useState("");

  const classificationKeys: INVESTIGATE_TAG_DISPLAY[] = Object.values(
    INVESTIGATE_TAG_DISPLAY,
  );

  const updateAlertStatus = async (
    newStatus: string,
    tag: INVESTIGATE_TAG_DISPLAY,
  ) => {
    if (newStatus === ALERT_PROCESS_STATUS_SDK.Investigate && !tag) {
      setIsOthersModalOpen(true);
      //setStatus(newStatus); // Update local state
      return;
    }

    const sdkTag = formatAlertTagDisplayToSDK(tag);
    try {
      await changeAlertStatus(
        user.orgId,
        activeAlert.id,
        newStatus,
        sdkTag,
        othersText,
      );

      setStatus(newStatus); // Update local state
      const _activeAlert = activeAlert;
      _activeAlert.status = newStatus;
      _activeAlert.tag = { name: sdkTag };
      setActiveAlert({
        ..._activeAlert,
      });
      globalMutate([
        `/alert/alerts/status/count?status=todo`,
        user.token,
        user?.orgId,
      ]);
      showToast(0, "Alert updated successfully", { minWidth: 300 });
    } catch (error) {
      showToast(1, "Failed to update the alert status. Please try again later");
      console.error("Error changing alert status:", error);
    }
  };

  useEffect(() => {
    if (activeAlert?.id !== alertId) {
      return;
    }
    setStatus(activeAlert?.status);
    if (activeAlert?.status !== ALERT_PROCESS_STATUS_SDK.Investigate) {
      setOthersText("");
      setTag(null);
    } else {
      console.log("cur activeAlert", activeAlert);
      setTag(
        formatAlertTagSDKToDisplay(
          activeAlert?.tag?.name as INVESTIGATE_TAG_SDK,
        ),
      );
      setOthersText(activeAlert?.tag?.desc || "");
    }
  }, [activeAlert]);

  const processKeys = Object.values(ALERT_PROCESS_STATUS_SDK);

  return (
    <div className="select-container">
      <Select
        className="select"
        popupClassName="alert-select-dropdown"
        style={{ width: "100%", height: "35px" }}
        dropdownStyle={{ borderRadius: "16px", padding: "4px 0" }}
        value={status}
        disabled={
          status === ALERT_PROCESS_STATUS_SDK.Investigate || isOthersModalOpen
        }
        onSelect={(e) => {
          updateAlertStatus(e, tag);
        }}
        options={processKeys?.map((key) => {
          return {
            value: key,
            label: formatAlertStatusSDKToDisplay(key),
          };
        })}
      />
      {isOthersModalOpen && (
        <div
          className={clsx(
            "absolute z-10 -right-[200px]  w-[520px] bg-white rounded-2xl p-6",
            tag === INVESTIGATE_TAG_DISPLAY.Others
              ? "-top-[405px]"
              : "-top-[335px]",
          )}
          style={{
            boxShadow:
              "0 4px 4px rgba(0,0,0,0.15), 0 -2px 4px rgba(0,0,0,0.15)",
          }}
        >
          <div className="grid grid-cols-3 mb-4">
            {classificationKeys?.map((key) => (
              <button
                key={key}
                className={clsx(
                  "rounded-lg h-[46px] w-[160px] text-center",
                  tag == key ? "bg-[#DCE7FD]" : "hover:bg-[#EEEEEE]",
                )}
                onClick={() => {
                  key != INVESTIGATE_TAG_DISPLAY.Others && setOthersText("");
                  setTag(key);
                }}
              >
                {key}
              </button>
            ))}
          </div>
          {tag === INVESTIGATE_TAG_DISPLAY.Others && (
            <Input
              className="h-[54px] rounded-2xl px-2"
              value={othersText}
              onChange={(e) => {
                setOthersText(e.target.value);
              }}
            />
          )}

          <div className="mt-4 flex justify-end gap-1">
            <button
              className="cursor-pointer px-4 py-2  bg-whitetext-sm font-semibold text-blue-500 transition-colors hover:text-blue-400 hover:border-blue-400"
              onClick={() => {
                setIsOthersModalOpen(false);
              }}
            >
              Cancel
            </button>
            <button
              className="bg-blue-500 px-8 py-2 rounded-2xl text-sm font-semibold text-white transition-colors hover:bg-blue-400 disabled:hover:bg-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
              onClick={() => {
                setIsOthersModalOpen(false);
                updateAlertStatus(ALERT_PROCESS_STATUS_SDK.Investigate, tag);
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AlertStatusChanger;
